import { startAvailabilityCleanupJob } from "./availabilityCron";
import { InvitationExpiryJob } from "./resendInvitationCron";


export const startAllCronJobs = () => {
    new InvitationExpiryJob().start();
    new startAvailabilityCleanupJob().start();

};
